import { render } from "./Assignees.vue?vue&type=template&id=5c32bd46"
import script from "./Assignees.vue?vue&type=script&lang=js"
export * from "./Assignees.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__